import type { ReactNode } from "react";
import { AnimatedHeight } from "./AnimatedHeight";
import { FadeInDown } from "./FadeInDown";

interface PreviewCardProps {
  animateOnMount?: boolean;
  children: ReactNode;
}

export const PreviewCard = ({ children, animateOnMount }: PreviewCardProps) => (
  <FadeInDown enabled={animateOnMount}>
    <AnimatedHeight>
      <div className="overflow-hidden rounded-3xl bg-white">{children}</div>
    </AnimatedHeight>
  </FadeInDown>
);
